module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-crustaceans.fa15c68a.svg";